import React, { useState, useRef, useEffect, useContext } from "react";
import { Image } from 'semantic-ui-react'
import loaderGif from "../assets/loader.gif";

const StarButton = ({ }) => {
    return <div className="loaderGif"><Image src={loaderGif} /></div>
};

export default StarButton;
